import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from './useTexts'

export function FailedToLoadNotifications() {
  const texts = useTexts()

  return (
    <Alert severity="error">
      <AlertTitle>{texts.failureTitle}</AlertTitle>
      {texts.failureDescription}
    </Alert>
  )
}
